import { postRequest, getRequest, downloadGetRequest } from '@/libs/axios';


// 订单列表
export const getOrderList = (params) => {
    return postRequest('/api/order/page', params)
}

// 导出
export const exportOrderList = (params) => {
    return postRequest('/api/order/exportOrderList', params)
}

// 导出的列表
export const exportRecordList = () => {
    return getRequest('/api/order/exportRecordList')
}

// 下载
export const downloadExportFile = (params) => {
    return downloadGetRequest('/api/order/downloadExportFile', params)
}